import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';

const SolarEnergy: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('SolarEnergy');
    return (
        <div className={styles.SolarEnergy}>
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoImg
                pc="https://websiteoss.ecoflow.com/upload/image/1751264503774/pc.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1751266949535/PowerStream-System-tech.jpg"
            />
        </div>
    );
};

export default SolarEnergy;
